import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      // Only redirect if on admin page
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin';
      }
    }
    return Promise.reject(error);
  }
);

// ============ API Functions ============

// Health check
export const healthCheck = async () => {
  const response = await api.get('/health');
  return response.data;
};

// Quiz
export const submitQuiz = async (quizData) => {
  const response = await api.post('/quiz', quizData);
  return response.data;
};

// Leads
export const createLead = async (leadData) => {
  const response = await api.post('/leads', leadData);
  return response.data;
};

export const getLeads = async () => {
  const response = await api.get('/leads');
  return response.data;
};

export const updateLeadStatus = async (leadId, status) => {
  const response = await api.patch(`/leads/${leadId}/status`, { status });
  return response.data;
};

export const deleteLead = async (leadId) => {
  const response = await api.delete(`/leads/${leadId}`);
  return response.data;
};

// Auth
export const login = async (email, password) => {
  const response = await api.post('/auth/login', { email, password });
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

// Report
export const requestReportAccess = async (email) => {
  const response = await api.post('/report/access', { email });
  return response.data;
};

// Stats
export const getStats = async () => {
  const response = await api.get('/stats');
  return response.data;
};

// Config
export const getConfig = async () => {
  const response = await api.get('/config');
  return response.data;
};

// Contact
export const submitContact = async (data) => {
  const response = await api.post('/contact', data);
  return response.data;
};

export const getContactMessages = async () => {
  const response = await api.get('/contact');
  return response.data;
};

export const updateContactStatus = async (messageId, status) => {
  const response = await api.patch(`/contact/${messageId}/status`, { status });
  return response.data;
};

export default api;
